import React, { useEffect, useState } from "react";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import ToastManager from "../../Components/ToastManager";
import { Constants } from "../Languages/Constants";

const EquipmentPrices = (props: any) => {
    const [dailyRate, setDailyRate] = useState<string | number>("");
    const [weeklyRate, setWeeklyRate] = useState<string | number>("");
    const [monthlyRate, setMonthlyRate] = useState<string | number>("");
    const [distanceRate, setDistanceRate] = useState<string | number>("");
    const [hourRate, setHourlyRate] = useState<string | number>("");
    const [engineDailyRate, setEngineDailyRate] = useState<string | number>("");
    const [engineWeeklyRate, setEngineWeeklyRate] = useState<string | number>("");
    const [engineMonthlyRate, setEngineMonthlyRate] = useState<string | number>("");

    useEffect(() => {
        const equipData = props.equipData;
        if (!equipData) return;

        const pricing = equipData.pricing || {};
        
        // Initially set pricing values from equipment data
        setDailyRate(pricing.dailyRate ?? "");
        setWeeklyRate(pricing.weeklyRate ?? "");
        setMonthlyRate(pricing.monthlyRate ?? "");
        setDistanceRate(pricing.distanceRate ?? "");
        setHourlyRate(pricing.engineRate ?? "");
        setEngineDailyRate(pricing.engineDailyRate ?? "");
        setEngineWeeklyRate(pricing.engineWeeklyRate ?? "");
        setEngineMonthlyRate(pricing.engineMonthlyRate ?? "");

        console.log(pricing);

        // Fetch default pricing for the equipment type
        const { equipmentType, year } = equipData;
        let qParam = `saasOrgId=${localStorage.getItem('saasorgId')}&equipmentType=${equipmentType}`;
        if (year) qParam += `&modelYear=${year}`;

        NetworkManager.sendJsonRequest("api/organization/getDefaultEquipmentTypePricing", "", qParam, "GET", true, (response: any) => {
            const restData = JSON.parse(response);
            console.log(restData);
            
            // Prefer existing pricing over defaults, falling back to empty string
            setDailyRate(pricing.dailyRate >= 0 ? pricing.dailyRate : (restData?.dailyRate ?? ""));
            setWeeklyRate(pricing.weeklyRate >= 0 ? pricing.weeklyRate : (restData?.weeklyRate ?? ""));
            setMonthlyRate(pricing.monthlyRate >= 0 ? pricing.monthlyRate : (restData?.monthlyRate ?? ""));
            setDistanceRate(pricing.distanceRate >= 0 ? pricing.distanceRate : (restData?.distanceRate ?? ""));
            setHourlyRate(pricing.engineRate >= 0 ? pricing.engineRate : (restData?.engineRate ?? ""));
            setEngineDailyRate(pricing.engineDailyRate >= 0 ? pricing.engineDailyRate : (restData?.engineDailyRate ?? ""));
            setEngineWeeklyRate(pricing.engineWeeklyRate >= 0 ? pricing.engineWeeklyRate : (restData?.engineWeeklyRate ?? ""));
            setEngineMonthlyRate(pricing.engineMonthlyRate >= 0 ? pricing.engineMonthlyRate : (restData?.engineMonthlyRate ?? ""));
        }, (err: any) => {
            console.log(err);
        });
    }, []);

    const onClickSavePrice = () => {
        const restObj: any = {
            pricing: {
                dailyRate,
                weeklyRate,
                monthlyRate,
                distanceRate,
                engineRate: hourRate,
                engineDailyRate,
                engineWeeklyRate,
                engineMonthlyRate
            }
        };

        const equipUrl = `api/equipment/${CommonUtil.SELECT_EQUIP_ID}`;

        NetworkManager.sendJsonRequest(equipUrl, restObj, '', 'PUT', true, (dataObj: any) => {
            if (dataObj && CommonUtil.parseData(dataObj)) {
                ToastManager.showToast('Equipment Prices are updated Successfully', 'Info');
            }
        }, (err: any) => {
            console.log(err);
        });
    };

    return(
        <>
            <div  className="container">
                <section className="pricing">

                    <p className="text-danger"><i
                        className="fa fa-exclamation-circle "></i> {CommonUtil.getMessageText(Constants.PRICING_UPDATE,"Pricing Updates will only affect new reservations.")}</p>
                    <div className="row">
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Daily-Rate.png" alt="Daily Rate" />
                                <span className="pricing-text">{CommonUtil.getMessageText(Constants.DAILY_RATE,"Daily Rate")}</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {dailyRate}</button> / {CommonUtil.getMessageText(Constants.DAY,"Day")}

                            </div>
                        </div>
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Daily-Rate.png" alt="Weekly Rate" />
                                <span className="pricing-text">{CommonUtil.getMessageText(Constants.WEEKLY_RATE,"Weekly Rate")}</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {weeklyRate}</button> / {CommonUtil.getMessageText(Constants.WEEK,"Week")}

                            </div>
                        </div>
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Daily-Rate.png" alt="Monthly Rate" />
                                <span className="pricing-text">{CommonUtil.getMessageText(Constants.MONTHLY_RATE,"Monthly Rate")}</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {monthlyRate}</button> / {CommonUtil.getMessageText(Constants.MONTH,"Month")}

                            </div>
                        </div>
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Distance-Rate.png"
                                     alt="Distance Rate" />
                                <span className="pricing-text">{CommonUtil.getMessageText(Constants.DISTANCE_RATE,"Distance Rate")}</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {distanceRate}</button> / {CommonUtil.getMessageText(Constants.MI,"MI")}
                            </div>
                        </div>
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Engine-Rate.png"
                                     alt="Engine Rate" />
                                <span className="pricing-text">Engine Rate</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {hourRate}</button> / {CommonUtil.getMessageText(Constants.HOUR,"HOUR")}
                            </div>
                        </div>
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Engine-Rate.png"
                                     alt="Engine Daily Rate" />
                                <span className="pricing-text">Engine Daily Rate</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {engineDailyRate}</button> / {CommonUtil.getMessageText(Constants.DAY,"Day")}
                            </div>
                        </div>
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Engine-Rate.png"
                                     alt="Engine Weekly Rate" />
                                <span className="pricing-text">Engine Weekly Rate</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {engineWeeklyRate}</button> / {CommonUtil.getMessageText(Constants.WEEK,"Week")}
                            </div>
                        </div>
                        <div className="col-sm-4 col-12 text-center">
                            <div className="shadow p-3 mb-3 bg-white border">
                                <img src="../../images/Engine-Rate.png"
                                     alt="Engine Monthly Rate" />
                                <span className="pricing-text">Engine Monthly Rate</span>
                                <button type="button" className="btn btn-outline-primary waves-effect waves-light">{CommonUtil.getCurrency()} {engineMonthlyRate}</button> / {CommonUtil.getMessageText(Constants.MONTH,"Month")}
                            </div>
                        </div>
                    </div>
                    <p style={{display:"none"}}>These are the rates that will apply for this rental. vhub will charge a
                        fee in addition to these rates. Please refer to our <a
                            href="#"><u><strong>Payment Terms</strong></u></a> for full details.
                    </p>
                </section>
            </div>
            <section  className="bottom" style={{display:"none"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-right">
                            <button type="button" className="btn  btn-outline-dark" data-dismiss="modal">Discard Changes</button>
                            <button type="button" className="btn btn-success" onClick={onClickSavePrice}>Save</button>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default EquipmentPrices;
